// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__y0CVO","footer":"ModalCreateQualiphyProcedure_footer__1M3hx","additionData":"ModalCreateQualiphyProcedure_additionData__2T87t"};